<template>
    <div class="components-forms">
        <div class="forms-header">
            <div class="header-list">
                <div v-for="item in headerlist"
                    :key="item.id" 
                    :class="{'active': activeTabs === item.id, 'header-item': true}"
                    @click="changeTabs(item)"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
        <div class="forms-body">
            <el-form v-if="activeTabs === 'company'" :model="companyForm" :rules="companyRules" ref="companyFormRef" label-width="0" class="demo-ruleForm">
                <el-form-item prop="company">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>企业名称
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.company"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入企业名称"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="logo">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>企业LOGO
                        </div>
                        <uploadVue showTishi="请上传企业LOGO" @upload="companyLogoUpload" @remove="companyLogoRemove"></uploadVue>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人姓名
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.name"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的姓名"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="title">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人职务
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.title"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的职务"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="speakerPhoto">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人照片
                        </div>
                        <uploadVue @upload="companySpeakUpload" @remove="companySpeakRemove"></uploadVue>
                    </div>
                </el-form-item>
                <el-form-item prop="phone">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>手机号</div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.phone"
                                style="height: 36px"
                                maxlength="11"
                                placeholder="请输入手机号"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="email">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>邮箱</div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.email"
                                style="height: 36px"
                                placeholder="请输入邮箱"
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicTitle">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>议题标题</div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.topicTitle"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入议题标题"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicAbstract">
                    <div class="content-item">
                        <div class="item-title">议题简介</div>
                        <div class="item-input">
                            <el-input
                                v-model="companyForm.topicAbstract"
                                maxlength="100"
                                :autosize="{ minRows: 2 }"
                                placeholder="请简要描述您的议题内容"
                                show-word-limit
                                type="textarea"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="industryField">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>所属领域</div>
                        <div class="item-input">
                            <el-radio-group v-model="industryField" @change="industryFieldChange">
                                <el-radio value="ai">AI技术与应用</el-radio>
                                <el-radio value="security">AI安全与创新</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicArea">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>议题领域</div>
                        <div class="item-input">
                            <el-select
                                v-model="companyForm.topicArea"
                                placeholder="请选择议题领域"
                                @focus="getAreaList(industryField)"
                            >
                                <el-option
                                    v-for="item in AreaList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="isChecked">
                    <el-checkbox v-model="companyForm.isChecked">
                        <span>阅读并同意
                            <a style="color: #409eff" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集协议》</a>
                            <a style="color: #409eff" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                        </span>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <div class="content-btn">
                        <el-button type="primary" @click="companySubmitForm(companyFormRef)">提交</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <el-form v-if="activeTabs === 'other'" :model="universityForm" :rules="universityRules" ref="universityFormRef" label-width="0" class="demo-ruleForm">
                <el-form-item prop="other">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>机构名称
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.other"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入机构名称"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="name">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人姓名
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.name"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的姓名"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="title">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>演讲人职务</div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.title"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的职务"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="logo">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人照片
                        </div>
                        <uploadVue @upload="universityLogoUpload" @remove="universityLogoRemove"></uploadVue>
                    </div>
                </el-form-item>
                <el-form-item prop="phone">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>手机号</div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.phone"
                                style="height: 36px"
                                maxlength="11"
                                placeholder="请输入手机号"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="email">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>邮箱</div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.email"
                                style="height: 36px"
                                placeholder="请输入邮箱"
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicTitle">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>议题标题</div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.topicTitle"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入议题标题"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicAbstract">
                    <div class="content-item">
                        <div class="item-title">议题简介</div>
                        <div class="item-input">
                            <el-input
                                v-model="universityForm.topicAbstract"
                                maxlength="100"
                                :autosize="{ minRows: 2 }"
                                placeholder="请简要描述您的议题内容"
                                show-word-limit
                                type="textarea"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="industryField">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>所属领域</div>
                        <div class="item-input">
                            <el-radio-group v-model="industryField" @change="industryFieldChange">
                                <el-radio value="ai">AI技术与应用</el-radio>
                                <el-radio value="security">AI安全与创新</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicArea">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>议题领域</div>
                        <div class="item-input">
                            <el-select
                                v-model="universityForm.topicArea"
                                placeholder="请选择议题领域"
                                @focus="getAreaList(industryField)"
                            >
                                <el-option
                                    v-for="item in AreaList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="isChecked">
                    <el-checkbox v-model="universityForm.isChecked">
                        <span>阅读并同意
                            <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集提交说明》</a>
                            <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                        </span>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <div class="content-btn">
                        <el-button type="primary" @click="universitySubmitForm(universityFormRef)">提交</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <el-form v-if="activeTabs === 'personal'" :model="personalForm" :rules="personalRules" ref="personalFormRef" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人姓名
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.name"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的姓名"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="logo">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>演讲人照片
                        </div>
                        <uploadVue @upload="personalLogoUpload" @remove="personalLogoRemove"></uploadVue>
                    </div>
                </el-form-item>
                <el-form-item prop="company">
                    <div class="content-item">
                        <div class="item-title">
                            公司名称
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.company"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入公司名称"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="title">
                    <div class="content-item">
                        <div class="item-title">
                            职务
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.title"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的职务"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="phone">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>手机号</div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.phone"
                                style="height: 36px"
                                maxlength="11"
                                placeholder="请输入手机号"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="email">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>邮箱</div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.email"
                                style="height: 36px"
                                placeholder="请输入邮箱"
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicTitle">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>议题标题</div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.topicTitle"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入议题标题"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicAbstract">
                    <div class="content-item">
                        <div class="item-title">议题简介</div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.topicAbstract"
                                maxlength="100"
                                :autosize="{ minRows: 2 }"
                                placeholder="请简要描述您的议题内容"
                                show-word-limit
                                type="textarea"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="industryField">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>所属领域</div>
                        <div class="item-input">
                            <el-radio-group v-model="industryField" @change="industryFieldChange">
                                <el-radio value="ai">AI技术与应用</el-radio>
                                <el-radio value="security">AI安全与创新</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicArea">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>议题领域</div>
                        <div class="item-input">
                            <el-select
                                v-model="personalForm.topicArea"
                                placeholder="请选择议题领域"
                                @focus="getAreaList(industryField)"
                            >
                                <el-option
                                    v-for="item in AreaList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="isChecked">
                    <el-checkbox v-model="personalForm.isChecked">
                        <span>阅读并同意
                            <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集提交说明》</a>
                            <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                        </span>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <div class="content-btn">
                        <el-button type="primary" @click="personalSubmitForm(personalFormRef)">提交</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <dialogVue ref="dialogRef" :data="posterInfo"></dialogVue>
    </div>
</template>
  
<script setup>
import { ref, onMounted, reactive } from 'vue';
import uploadVue from './myUpload.vue';
import dialogVue from './myDialog.vue';
import { submitForm } from '@/api/2025';
import { ElLoading,ElMessage } from 'element-plus';

let activeTabs = ref('company');
let dialogRef = ref(null)

let headerlist = ref([
{
    title: '企业',
    id: 'company'
},
{
    title: '机构',
    id: 'other'
},
{
    title: '个人',
    id: 'personal'
}
]);

let posterInfo = ref({}) //海报列表

const changeTabs = (item) => {
    activeTabs.value = item.id;
}

let AreaList = ref([])
const getAreaList = (type) => {
    if(type == 'ai'){
        AreaList.value = [
            "大模型技术",
            "智能体技术",
            "具身智能技术",
            "企业级AI应用",
            "垂直行业AI应用"
        ]
    }else if(type == 'security'){
        AreaList.value = [
            "模型层安全",
            "数据层安全",
            "应用层安全",
            "AI治理与合规",
            "安全大模型",
            "安全智能体",
            "新型安全威胁与防御",
            "企业级应用",
            "垂直行业应用"
        ]
    }
}
const industryFieldChange = (val) => {
    companyForm.topicArea = ''
    universityForm.topicArea = ''
    personalForm.topicArea = ''
}

let industryField = ref('ai')
let companyFormRef = ref(null)
const companyForm = reactive({
    logo: [],
    company: '',
    name: '',
    title: '',
    speakerPhoto: [],
    phone: '',
    email: '',
    topicTitle: '',
    topicAbstract: '',
    topicArea: '',
    isChecked: false,
    Orientation: 1
})
let universityFormRef = ref(null)
const universityForm = reactive({
    other: '',
    logo: [],
    name: '',
    title: '',
    phone: '',
    email: '',
    topicTitle: '',
    topicAbstract: '',
    topicArea: '',
    isChecked: false,
    Orientation: 1
})
let personalFormRef = ref(null)
const personalForm = reactive({
    logo: [],
    name: '',
    company: '',
    title: '',
    phone: '',
    email: '',
    topicTitle: '',
    topicAbstract: '',
    topicArea: '',
    isChecked: false,
    Orientation: 1
})

const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请填写手机号'));
    }
    if (!(/^1[3456789]\d{9}$/.test(value))) {
        return callback(new Error('手机号格式有误，请检查'));
    }
    return callback();
}
const checkEmail = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请填写邮箱'));
    }
    if (!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value))) {
        return callback(new Error('邮箱格式有误，请检查'));
    }
    return callback();
}
const checkRules = (rule, value, callback) => {
    if (value==false) {
        return callback(new Error('请阅读并同意协议和规则'));
    }
    return callback();
}

const companyRules = ref({
    logo: [
        { required: true, message: '请上传企业logo', trigger: 'upload' },
    ],
    speakerPhoto: [
        { required: true, message: '请上传演讲人照片', trigger: 'upload' },
    ],
    name: [
        { required: true, message: '请输入演讲人姓名', trigger: 'blur' },
    ],
    title: [
        { required: true, message: '请输入演讲人职务', trigger: 'blur' },
    ],
    company: [
        { required: true, message: '请输入企业名称', trigger: 'blur'},
    ],
    phone: [
        { required: true, validator: checkPhone, trigger: 'blur' },
    ],
    email: [
        { required: true, validator: checkEmail, trigger: 'blur' },
    ],
    topicTitle: [
        { required: true, message: '请输入议题标题', trigger: 'blur' },
    ],
    // topicAbstract: [
    //     { required: true, message: '请输入议题简介', trigger: 'blur' },
    // ],
    topicArea: [
        { required: true, message: '请选择议题领域', trigger: 'change' }
    ],
    isChecked: [
        { required: true, validator: checkRules, trigger: 'change' },
    ]
});
const universityRules = ref({
    logo: [
        { required: true, message: '请上传演讲人照片', trigger: 'upload' },
    ],
    name: [
        { required: true, message: '请输入演讲人姓名', trigger: 'blur' },
    ],
    title: [
        { required: true, message: '请输入演讲人职务', trigger: 'blur' },
    ],
    other: [
        { required: true, message: '请输入机构名称', trigger: 'blur'},
    ],
    phone: [
        { required: true, validator: checkPhone, trigger: 'blur' },
    ],
    email: [
        { required: true, validator: checkEmail, trigger: 'blur' },
    ],
    topicTitle: [
        { required: true, message: '请输入议题标题', trigger: 'blur' },
    ],
    // topicAbstract: [
    //     { required: true, message: '请输入议题简介', trigger: 'blur' },
    // ],
    topicArea: [
        { required: true, message: '请选择议题领域', trigger: 'change' }
    ],
    isChecked: [
        { required: true, validator: checkRules, trigger: 'change' },
    ]
});
const personalRules = ref({
    logo: [
        { required: true, message: '请上传演讲人照片', trigger: 'upload' },
    ],
    name: [
        { required: true, message: '请输入演讲人姓名', trigger: 'blur' },
    ],
    phone: [
        { required: true, validator: checkPhone, trigger: 'blur' },
    ],
    email: [
        { required: true, validator: checkEmail, trigger: 'blur' },
    ],
    topicTitle: [
        { required: true, message: '请输入议题标题', trigger: 'blur' },
    ],
    // topicAbstract: [
    //     { required: true, message: '请输入议题简介', trigger: 'blur' },
    // ],
    topicArea: [
        { required: true, message: '请选择议题领域', trigger: 'change' }
    ],
    isChecked: [
        { required: true, validator: checkRules, trigger: 'change' },
    ]
});

const companyLogoUpload = (file,orientation) => {
    companyForm.Orientation = orientation
    if(file[0]?.url){
        companyForm.logo[0] = file[0].url
        companyFormRef.value.clearValidate('logo')
    }
}
const companyLogoRemove = (file) => {
    companyForm.logo = []
}
const companySpeakUpload = (file) => {
    if(file[0]?.url){
        companyForm.speakerPhoto[0] = file[0].url
        companyFormRef.value.clearValidate('speakerPhoto')
    }
}
const companySpeakRemove = (file) => {
    companyForm.speakerPhoto = []
}
const universityLogoUpload = (file,orientation) => {
    universityForm.Orientation = orientation
    if(file[0]?.url){
        universityForm.logo[0] = file[0].url
        universityFormRef.value.clearValidate('logo')
    }
}
const universityLogoRemove = (file) => {
    universityForm.logo = []
}
const personalLogoUpload = (file,orientation) => {
    personalForm.Orientation = orientation
    if(file[0]?.url){
        personalForm.logo[0] = file[0].url
        personalFormRef.value.clearValidate('logo')
    }
}
const personalLogoRemove = (file) => {
    personalForm.logo = []
}

const loadingInstance = ref(null)
const openLoading = () => {
    loadingInstance.value = ElLoading.service({
        lock: true,
        text: '正在生成您的专属海报，请稍候...',
        svg: `
            <path class="path" d="
            M 30 15
            L 28 17
            M 25.61 25.61
            A 15 15, 0, 0, 1, 15 30
            A 15 15, 0, 1, 1, 27.99 7.5
            L 15 15
            " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
        `,
        svgViewBox: "-10, -10, 50, 50",
        background: 'rgba(0, 0, 0, 0.8)',
        customClass: 'my-loading',
    })
}
const closeLoading = () => {
    loadingInstance.value.close()
}

const companySubmitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
        let newData = JSON.parse(JSON.stringify(companyForm))
        newData.logo = newData.logo[0]
        newData.speakerPhoto = newData.speakerPhoto[0]
        newData.industryField = industryField.value
        newData.submissionMode = 'speak'
        newData.identityType = 'company'
        newData.form_id = 1
        openLoading()
        return submitForm(newData).then(res => {
            if (res.data.msg == "SUCCESS") {
                posterInfo.value = {
                    title: newData.topicTitle,
                    avatar: newData.speakerPhoto,
                    name: newData.name,
                }
                setTimeout(() => {
                    dialogRef.value.openModel()
                    closeLoading()
                },2000)
            }else{
                closeLoading()
                ElMessage.error(res.data.msg)
            }
        })
    } else {
      console.log('error submit!', fields)
    }
  })
}
const universitySubmitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
        let newData = JSON.parse(JSON.stringify(universityForm))
        newData.logo = newData.logo[0]
        newData.industryField = industryField.value
        newData.submissionMode = 'speak'
        newData.identityType = 'other'
        newData.form_id = 1
        openLoading()
        return submitForm(newData).then(res => {
            if (res.data.msg == "SUCCESS") {
                posterInfo.value = {
                    title: newData.topicTitle,
                    avatar: newData.logo,
                    name: newData.name,
                }
                setTimeout(() => {
                    dialogRef.value.openModel()
                    closeLoading()
                },2000)
            }else{
                closeLoading()
                ElMessage.error(res.data.msg)
            }
        })
    } else {
      console.log('error submit!', fields)
    }
  })
}
const personalSubmitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
        let newData = JSON.parse(JSON.stringify(personalForm))
        newData.logo = newData.logo[0]
        newData.industryField = industryField.value
        newData.submissionMode = 'speak'
        newData.identityType = 'personal'
        newData.form_id = 1
        openLoading()
        return submitForm(newData).then(res => {
            if (res.data.msg == "SUCCESS") {
                posterInfo.value = {
                    title: newData.topicTitle,
                    avatar: newData.logo,
                    name: newData.name,
                }
                setTimeout(() => {
                    dialogRef.value.openModel()
                    closeLoading()
                },2000)
            }else{
                closeLoading()
                ElMessage.error(res.data.msg)
            }
        })
    } else {
      console.log('error submit!', fields)
    }
  })
}


</script>

<style lang="scss" scoped>
.components-forms {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .forms-header{
    width: 100%;
    display: flex;
    justify-content: center;
    .header-list{
      display: flex;
      align-items: center;
      gap: 10px;
      .header-item{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 260px;
        height: 60px;
        box-sizing: border-box;
        border-left: 1px solid rgb(170, 189, 225);
        border-right: 1px solid rgb(170, 189, 225);
        border-top: 1px solid rgb(170, 189, 225);
        border-radius: 16px 16px 0px 0px;
        background: rgb(227, 236, 255);
        color: rgb(110, 134, 179);
        font-family: Source Han Sans;
        font-size: 22px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 15px;
        &:hover{
            color: rgb(25, 104, 255);
        }
        &.active{
            height: 61px;
            margin-bottom: -1px;
            border-left: 1px solid rgb(211, 211, 211);
            border-right: 1px solid rgb(211, 211, 211);
            border-top: 1px solid rgb(211, 211, 211);
            border-radius: 16px 16px 0px 0px;
            background: rgb(255, 255, 255);
            color: rgb(25, 104, 255);
            font-family: Source Han Sans;
            font-size: 22px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 15px;
            z-index: 1;
        }
      }
    }
  }
  .forms-body{
    width: 800px;
    padding: 45px 60px;
    border: 1px solid rgb(211, 211, 211);
    border-radius: 0px 0px 16px 16px;
    background: rgb(255, 255, 255);
        .content-item{
            display: flex;
            flex-direction: column;
            width: 100%;
            .item-title{
                color: rgb(44, 44, 44);
                font-family: Source Han Sans;
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
                letter-spacing: 0px;
                margin-bottom: 8px;
                margin-top: 12px;
                span{
                    color: #EB2934;
                    margin-right: 4px;
                }
            }
            :deep(.el-select__wrapper){
                min-height: 36px;
            }
        }
        .content-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-top: 20px;
            :deep(.el-button){
                width: 180px;
                height: 54px;
                color: rgb(255, 255, 255);
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 10px;
            }
        }
    }
    :deep(.el-checkbox__input.is-checked+.el-checkbox__label){
        color: #606266;
    }
}


</style>